import React from 'react';
import { Collapse, Tag, Row, Col, Card } from 'antd';
import TerminalDropdown from './TerminalDropdown';

const { Panel } = Collapse;

const OutletList = ({ outlet, index, setSelectedSerials, selectedSerials }) => {
  const header = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <Tag>Outlet {index + 1}</Tag>
    </div>
  );
  return (
    <Collapse defaultActiveKey={['1']} style={{ marginBottom: 16 }}>
      <Panel header={header} key="1">
        <Card size="small" style={{ marginBottom: 12 }}>
          <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col xs={24} sm={8}>
              <strong>Outlet Code:</strong> {outlet.code}
            </Col>
            <Col xs={24} sm={8}>
              <strong>Name:</strong> {outlet.name}
            </Col>
            <Col xs={24} sm={8}>
              {outlet.mcc && (
                <>
                  <strong>MCC:</strong> {outlet.mcc}
                </>
              )}
            </Col>
          </Row>

          <Row gutter={16} style={{ marginBottom: 8 }}>
            {outlet.province && (
              <Col xs={24} sm={8}>
                <strong>Province:</strong> {outlet.province}
              </Col>
            )}
            {outlet.district && (
              <Col xs={24} sm={8}>
                <strong>District:</strong> {outlet.district}
              </Col>
            )}
            {outlet.street && (
              <Col xs={24} sm={8}>
                <strong>Street:</strong> {outlet.street}
              </Col>
            )}
          </Row>

          <Row gutter={16}>
            {outlet.contactPerson && (
              <Col xs={24} sm={12}>
                <strong>Contact Person:</strong> {outlet.contactPerson}
              </Col>
            )}
          </Row>
        </Card>
        <Card size="small" title="Select Terminal">
          <TerminalDropdown
            setSelectedSerials={setSelectedSerials}
            selectedSerials={selectedSerials}
            terminals={outlet?.terminals || []}
          />
        </Card>
      </Panel>
    </Collapse>
  );
};

export default OutletList;
